<div class="container-modal">
  <div nz-row [nzGutter]="[30, 10]">
    <div nz-col [nzXs]="24" [nzLg]="9">
      <nz-input-group [nzSuffix]="suffixIconSearch">
        <input type="text" [(ngModel)]="searchNotes" nz-input placeholder="Buscar nota por título" (keyup)="onSearch($event)" />
      </nz-input-group>
      <ng-template #suffixIconSearch>
        <i nz-icon nzType="search"></i>
      </ng-template>
    </div>
    <div nz-col [nzXs]="24" [nzLg]="9" *ngIf="!userLogged.patients">
      <nz-select [(ngModel)]="filterNotes" nzPlaceHolder="Selecciona que notas mostrar" style="width: 100%;" nzAllowClear
        (ngModelChange)="onChangeSelect()">
        <nz-option nzValue="todas" nzLabel="Todas las notas"></nz-option>
        <nz-option nzValue="shared" nzLabel="Notas compartidas"></nz-option>
      </nz-select>
    </div>
    <div nz-col [nzXs]="24" [nzLg]="6">
      <button
        *ngIf="!userLogged.patients"
        class="btn-next-step"
        (click)="onEmitAddNote()"
        nz-button nzType="primary">
        <i nz-icon nzType="plus" nzTheme="outline"></i>
        Agregar nota
      </button>
    </div>
  </div>
  <div class="d-flex mt-md" nz-row [nzGutter]="[0,30]">
    <div *ngIf="loadNotes && (this.notesByService$ | async)" nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="noteSelectedId ? 16 : 24"
      [nzXl]="noteSelectedId ? 16 : 24">
      <ng-container>
        <nz-tabset [nzSelectedIndex]="(currentNotesTab === 'BY_SERVICE') ? 0: 1" (nzSelectedIndexChange)="onChangeTabNotes($event)">
          <nz-tab nzTitle="Notas del servicio">
            <div *ngIf="(this.notesByService$ | async)?.length> 0">
              <div nz-row [nzGutter]="[16, 16]">
                <div nz-col nzXs="24" nzSm="24" nzMd="12" [nzLg]="12" [nzXl]="noteSelectedId ? 12 : 8" *ngFor="let noteObject of
                  (this.notesByService$ | async); index as i">
                  <app-card-note-appointment
                    class="cursor-pointer"
                    [appointmentNote]="noteObject"
                    [userLogged]="this.userLogged"
                    [active]="noteObject._id === noteSelectedId"
                    [allowToAssign]="allowToAssign"
                    [clinicId]="clinicId"
                    [serviceId]="serviceId"
                    [patientId]="patientId"
                    [canInteract]="this.roleAuthUser !== this.roles.PATIENT"
                    (click)="onSelectedNote(noteObject)"
                    (changeShared)="onChangeSharedNote($event, 'serviceNotes')"
                    (delete)="onDeleteNote($event)"
                  ></app-card-note-appointment>
                </div>
              </div>
              <app-paginator class="mt-xlg" [configuration]="paginatorConfig" [total]="totalNotesByService$ | async" [index]="indexPageService"
                (change)="onChangePaginationByService($event)"></app-paginator>
            </div>
            <p class="text-info" *ngIf="(this.notesByService$ | async)?.length === 0">No hay notas</p>
          </nz-tab>
          <nz-tab nzTitle="Notas de la cita">
            <div *ngIf="(this.notes$ | async)?.length> 0">
              <!--
              TODO: revisar que ponga el nombre del paciente si son mas de un paciente
              <p *ngIf="notesAppointment.users.length > 1" class="text-info mb-xs">Notas para el paciente {{ (userAppointment.user.name ?? '') + ' ' + (userAppointment.user.lastname ?? '') }}</p>
              -->
              <div nz-row [nzGutter]="[16, 16]">
                <div nz-col nzXs="24" nzSm="24" nzMd="12" [nzLg]="12" [nzXl]="noteSelectedId ? 12 : 8" *ngFor="let noteObject of (this.notes$ |
                  async); index as i">
                  <app-card-note-appointment class="cursor-pointer"
                    [appointmentNote]="noteObject"
                    [userLogged]="this.userLogged"
                    [active]="noteObject._id === noteSelectedId"
                    [allowToAssignToService]="allowToAssign"
                    [clinicId]="clinicId"
                    [serviceId]="serviceId"
                    [patientId]="patientId"
                    (click)="onSelectedNote(noteObject)"
                    (changeShared)="onChangeSharedNote($event, 'appointmentNotes')"
                    (delete)="onDeleteNote($event)"></app-card-note-appointment>
                </div>
              </div>
              <app-paginator class="mt-xlg" [configuration]="paginatorConfig" [total]="total$ | async" [index]="indexPage"
                (change)="onChangePagination($event)"></app-paginator>
            </div>
            <p class="text-info" *ngIf="(this.notes$ | async)?.length === 0">No hay notas</p>
          </nz-tab>
        </nz-tabset>
      </ng-container>
    </div>
    <div *ngIf="noteSelectedId" nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="8" [@fadeInAnimation]>
      <div class="container-extra">
        <!-- <h2 class="modal-header-title text-subtitle-bold">Nota seleccionada

        </h2> -->
        <div class="registered-info d-flex align-items-center justify-content-between pl-xlg">
          <p class="text-subtitle registered-by">
            <span class="close-selected" (click)="noteSelectedId=null;">cerrar</span>
            <span *ngIf="noteSelected.createdAt | isToday; else notToday">HOY</span></p>
          <ng-template #notToday>
            <span>{{ noteSelected.createdAt | date }}</span>
          </ng-template>
          <div class="user">
            <app-avatar-group class="mr-xs" [users]="[noteSelected.creator]" [numberVisibleElements]="1"></app-avatar-group>
            <p class="text-subtitle-bold">{{ (noteSelected.creator.name ?? '') + ' ' + (noteSelected.creator.lastname ?? '') }}</p>
          </div>
        </div>
        <nz-divider style="margin: 20px 0 30px 0;"></nz-divider>
        <div class="container-text-note pl-xlg">
          <!-- <ng-scrollbar class="my-scrollbar">

          </ng-scrollbar> -->
          <p class="text-regular-14 content-note" [innerHTML]="noteSelected.note | sanitizerHtml"></p>
        </div>
      </div>
    </div>
  </div>
</div>
